<script>
	import { page } from '$app/stores';
	import { basketListnew } from '$lib/store/newbasket';
	import { lang } from '$lib/translations/cart';
	import { variables } from '$lib/variables';
	import { fly } from 'svelte/transition';
	export let item;
	export let SuccesMessage3;
	$: if (SuccesMessage3) {
		setTimeout(() => {
			SuccesMessage3 = false;
		}, 3000);
	}
</script>

<!-- Global notification live region, render this permanently at the end of the document -->
<div
	transition:fly={{
		y: -200,
		duration: 500
	}}
	aria-live="assertive"
	class="pointer-events-none fixed -top-2 left-0 z-[2000] inset-0 flex px-4 py-6 items-start sm:p-6"
>
	<div class="flex w-full flex-col items-center space-y-4 sm:items-end">
		<div
			class="pointer-events-auto flex w-full max-w-md rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
		>
			<div class="w-0 flex-1 p-4">
				<div class="flex items-start">
					<div class="flex-shrink-0 pt-0.5">
						<img
							class="h-10 w-10 rounded-full"
							src="{item.photos[0].image_thumbnail}"
							alt=""
						/>
					</div>
					<div class="ml-3 w-0 flex-1">
						<p class="text-sm font-medium text-gray-900">
							{item.product[`name${$page.data.host}`]}
						</p>
						<p class="mt-1 text-sm text-gray-500">
							{#if Number(item.sale_price) != 0}
								<span class="text-sm text-custom-black">
									<span style="font-weight: 600;"
										>{Number(item.sale_price).toLocaleString('ru')}</span
									>
									₽
								</span>
							{:else}
								<span class="text-sm mr-[4px] text-custom-black">
									{#if !item.pre_order}
										<span style="font-weight: 600;">{Number(item.price).toLocaleString('ru')}</span>
									{:else}
										<span style="font-weight: 600;"
											>{Number(item.price_pre_order).toLocaleString('ru')}</span
										>
									{/if}
									₽
								</span>
							{/if}
						</p>
					</div>
				</div>
			</div>
			<div class="flex relative justify-center items-center px-2 border-l border-gray-200">
				<svg
					class="h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					aria-hidden="true"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
					/>
				</svg>
				<div
					transition:fly={{
						y: -200,
						duration: 1000
					}}
					class="absolute top-3 right-1 inline-flex pt-1 items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full"
				>
					{$basketListnew.order_items.length}
				</div>
			</div>
		</div>
	</div>
</div>
